import { ALL_KEYS, AlertSettings, DEFAULT_RECIPIENTS, RecipientsState, SectionKey } from '../config/alertFields';

interface SavedAlertSettings {
  settings?: AlertSettings;
  recipients?: Record<string, any>;
}

/**
 * Turns the saved API payload into full page state: every known trigger gets an array
 * (legacy rows stored a single string), every section gets numeric ids and a boolean flag.
 */
export const normalizeAlertSettings = (
  result: SavedAlertSettings = {},
): { settings: AlertSettings; recipients: RecipientsState } => {
  const saved = result.settings || {};
  const settings: AlertSettings = {};
  ALL_KEYS.forEach((key) => {
    const val = saved[key];
    settings[key] = Array.isArray(val) ? val : val ? [val as unknown as string] : [];
  });

  const savedRecipients = result.recipients || {};
  const recipients: RecipientsState = { ...DEFAULT_RECIPIENTS };
  (Object.keys(DEFAULT_RECIPIENTS) as SectionKey[]).forEach((sk) => {
    const sectionData = savedRecipients[sk] || {};
    recipients[sk] = {
      admin_user_ids: Array.isArray(sectionData.admin_user_ids) ? sectionData.admin_user_ids.map(Number) : [],
      salesperson_user_ids: Array.isArray(sectionData.salesperson_user_ids)
        ? sectionData.salesperson_user_ids.map(Number)
        : [],
      notify_salespeople: Boolean(sectionData.notify_salespeople),
    };
  });

  return { settings, recipients };
};
